module.exports = __webpack_public_path__ + "img/tuoli.23545fc5.webp";